var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ImageFullsize",class:("--align-" + _vm.align)},[_c('img',{ref:"Image",staticClass:"ImageFullsize_img",class:{ '--loaded': !_vm.loadingBackground },attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }